<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">Webinars</div>
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>

    <lcontainer>
      <div class="flex justify-between">
        <page-header class="py-2 tenant-main-color">Below are scheduled Webinars available for your courses</page-header>
        <div class="flex m-2"></div>
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <ul class="flex justify-center m-4">
          <li class="mr-3">
            <a :class="['inline-block bg-tab border  rounded py-1 px-3  ',upcoming ? 'bg-tab-active  text-white': 'hover:border-gray-200 border-white ']" @click="toggleUpcomingTab" href="#">Upcoming Webinars</a>
          </li>
          <li class="mr-3">
            <a :class="['inline-block border py-1   rounded px-3',past ? 'bg-tab-active text-white' : 'hover:border-gray-200   hover:bg-gray-200']" @click="togglePastTab" href="#">Past Webinars</a>
          </li>

        </ul>
        <linput
          v-model="search"
          class="py-2"
          placeholder="Search by Course Name"
        />
      </div>
      <!-- <WebinarTable /> -->

      <div class="flex flex-wrap" v-if="upcoming">
        <div
          v-for="(webinar, i) in searchUpcomingWebinar"
          :key="i"
          class="w-full md:w-1/3 flex"
        >
          <webinar-card :webinar="webinar" class=" m-4" />
        </div>
        <empty v-if="!searchUpcomingWebinar.length > 0"  message="Webinars Not Found" />
      </div>

      <div class="flex flex-wrap" v-if="past">
        <div
                v-for="(webinar, i) in searchPastWebinar"
                :key="i"
                class="w-full md:w-1/3 flex"
        >
          <webinar-card :webinar="webinar" class=" m-4" />
        </div>
        <empty v-if="!searchPastWebinar.length > 0"  message="Webinars Not Found" />
      </div>
      <div />
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Empty from "../../../components/general/Empty";
export default {
  components: {
    Empty,
    WebinarCard: () => import("@/components/learner/webinar-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    WebinarTable: () => import("@/components/tenant/webinar-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
  },
  data() {
    return {
      form: {},
      error: {},
      search: "",
      webinars: [],
      upcoming:true,
      past:false,
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchTenantCourses", "deleteTenantCourse", "getWebinars"]),
    togglePastTab(){
      this.past = true;
      this.upcoming = false;
    },
    toggleUpcomingTab(){
      this.upcoming = true;
      this.past = false;
    }
  },
  computed: {
    ...mapGetters(["getTenantCourses"]),
    searchUpcomingWebinar() {
      let date = new Date();
      return this.webinars.filter((webinar) => {
        return webinar.course.title.toLowerCase().match(this.search.toLowerCase()) && webinar.start_time > date.toISOString() ;
      });
    },
    searchPastWebinar() {
      let date = new Date();
      return this.webinars.filter((webinar) => {
        return webinar.course.title.toLowerCase().match(this.search.toLowerCase()) && webinar.start_time < date.toISOString() ;
      });
    },
  },
  async mounted() {
    this.$Bus.$on("delete-course", (data) => {
      if (
        confirm(
          "Are you sure you want to delete this course, all associated courses & modules will be deleted"
        )
      ) {
        this.deleteTenantCourse({ id: data });
      }
    });
    this.webinars = await this.getWebinars();
  },
};
</script>
<style  scoped lang="scss">
  .bg-tab-active{
    background: color(lms-tenant)!important;
  }
</style>
